import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconGooglePlayBrandedStyle0 = cosmosIconCss;

const CosmosIconGooglePlayBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGooglePlayBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4558f236a9422462bd8bf00f60215f278ba520da', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd169b6bc9dd517e70062e8ee22923b36b0c13e96', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8fadb9f759df5d4ae493d43bc291336fb4df0be8', d: "M14.139 13.372a410.516 410.516 0 0 1 3.057-1.824c.35-.202.71-.739 0-1.156-.23-.131-1.463-.87-3.057-1.824l-2.195 2.408 2.195 2.396Z", fill: "#FBBC04" }), h("path", { key: 'a75e2ff2f0a295767d6d659cec304d5daff626d7', d: "m11.944 10.976-7.009 7.712c.164.024.35-.024.568-.155.458-.274 5.328-3.182 8.636-5.161l-2.195-2.396Z", fill: "#EA4335" }), h("path", { key: 'ad00882d8baaa222aa9390e20373caf3acc717a5', d: "m11.944 10.976 2.195-2.408s-8.145-4.85-8.636-5.137a.794.794 0 0 0-.579-.119l7.02 7.664Z", fill: "#34A853" }), h("path", { key: 'a3553bfc025ced7caacf4d53749badaad8d04382', d: "m11.944 10.976-7.02-7.664c-.284.072-.524.346-.524.906v13.564c0 .513.186.882.535.918l7.01-7.724Z", fill: "#4285F4" }))));
    }
    static get style() { return CosmosIconGooglePlayBrandedStyle0; }
}, [1, "cosmos-icon-google-play-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-google-play-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-google-play-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGooglePlayBranded$1);
            }
            break;
    } });
}

const CosmosIconGooglePlayBranded = CosmosIconGooglePlayBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGooglePlayBranded, defineCustomElement };
